import { useQuery } from "@tanstack/react-query";
import { Disclosure } from "@/components/Disclosure";
import { sendAjaxRequest } from "@/ts/api/comunicacion";
import { TablaPedidos } from "./TablaPedidos";
import { useState, } from "react";
import { Breadcrumb } from "@/components/Breadcrumb";

export function EmpaquetadoPedidosPage() {
	const [filtroCiclo, setFiltroCiclo] = useState("");
	const [filtroMedio, setFiltroMedio] = useState("");
	const [filtroPedido, setFiltroPedido] = useState("");

	return (
		<div id="content" className="content" >
			<title>Piher | Gestor de listado de Ordenes </title>
			<div>
				<Breadcrumb
					sectionTitle="Empaquetado"
					links={[
						{ label: "Listado de Pedidos", active: true }
					]}
				/>

				<Disclosure style={{ marginBottom: 20 }}>
					{/* First element is the summary, second is the content */}
					<h4 className="panel-title panel-heading senalar">
						Filtro
					</h4>
					<FiltroPedidos
						filtroCiclo={filtroCiclo} setFiltroCiclo={setFiltroCiclo}
						filtroMedio={filtroMedio} setFiltroMedio={setFiltroMedio}
						filtroPedido={filtroPedido} setFiltroPedido={setFiltroPedido}
					/>
				</Disclosure>

				<div className="table-responsive">
					<TablaPedidos
						filtroCiclo={filtroCiclo}
						filtroMedio={filtroMedio}
						filtroPedido={filtroPedido}
					/>
				</div>
			</div>
		</div>
	);
}

interface FiltroPedidosProps {
	readonly filtroCiclo: string;
	readonly setFiltroCiclo: (value: string) => void;
	readonly filtroMedio: string;
	readonly setFiltroMedio: (value: string) => void;
	readonly filtroPedido: string;
	readonly setFiltroPedido: (value: string) => void;
}
function FiltroPedidos(props: FiltroPedidosProps) {
	return (
		<div style={{ padding: 30 }} role="tabpanel">
			<div >
				<label >Ciclos: </label>
				<select className="form-control " value={props.filtroCiclo} onChange={event => { props.setFiltroCiclo(event.target.value); }}>
					<option value="" >Elige</option>
				</select>
			</div>
			<div >
				<label >Transportista: </label>
				<select className="form-control " value={props.filtroMedio} onChange={event => { props.setFiltroMedio(event.target.value); }}>
					<option value="" >Elige</option>
				</select>
			</div>
			<div >
				<label >Pedido:</label>
				<input className="form-control " type="text" placeholder="Nº de pedido" value={props.filtroPedido} onChange={event => { props.setFiltroPedido(event.target.value); }} />
			</div>
		</div>
	);
}

export function getPedidosFiltrados(filtroCiclo: string | null, filtroMedio: string | null, filtroPedido: string | null, data: Record<number, Ciclo>) {
	let ciclosFiltrados: Ciclo[];
	if (filtroCiclo != null && filtroCiclo != "") {
		ciclosFiltrados = [data[parseInt(filtroCiclo, 10)]];
	} else {
		ciclosFiltrados = Object.values(data);
	}
	const pedidosFiltrados = [];
	for (const ciclo of ciclosFiltrados) {
		const pedidosCicloFiltrados = ciclo.pedidos.filter(pedido => {
			if (filtroMedio != null && filtroMedio != "")
				if (pedido.idMedio != parseInt(filtroMedio, 10)) return false;
			if (filtroPedido != null && filtroPedido != "")
				if (!String(pedido.idPedido).includes(filtroPedido)) return false;
			return true;
		});
		pedidosFiltrados.push(...pedidosCicloFiltrados);
	}

	return pedidosFiltrados;
}

export function usePedidosVenta() {
	return useQuery<Record<number, Ciclo>>({
		queryKey: ["getPedidosLanzados"],
		queryFn: () => {
			const url = "/api/v1/getPedidosLanzados";
			return sendAjaxRequest<Record<number, Ciclo>>("GET", url);
		},
	});
}

export interface Ciclo {
	idCiclo: number;
	prioridadCiclo: number;
	pedidos: Pedido[];
}
export interface Pedido {
	idMedio: number;
	nombreMedio: number;
	idPedido: number;
	nombreCliente: string;
	timestampPedido: number;
}